import React, { ComponentType, ReactNode } from 'react';
import { TableCell, TableHead as MuiTableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TableCardRowProps } from '../Table/types';

const HeadTableCell = styled(TableCell)(() => ({
  verticalAlign: 'bottom',
  fontWeight: 700,
}));

type HeaderCellComponentProps = {
  header?: ReactNode;
  className?: string;
};

const HeaderCellComponent = ({ header, className }: HeaderCellComponentProps) => {
  if (header) {
    return <HeadTableCell className={className}>{header}</HeadTableCell>;
  } else {
    return null;
  }
};

type TableHeadProps = {
  rowComponent: ComponentType<TableCardRowProps<any>>;
};

const TableHead = ({ rowComponent: RowComponent }: TableHeadProps) => {
  return (
    <MuiTableHead>
      <RowComponent item={{}} cellComponent={HeaderCellComponent} rowComponent={TableRow} />
    </MuiTableHead>
  );
};

export { TableHead };
